import * as React from 'react';
import { makeStyles, createStyles, Typography } from '@material-ui/core';
import cn from 'classnames';
import { NegotiationOption, OutDebt } from '../../generated/graphql';
import { TranquiTheme } from '../../containers/App/theme';
import RenderText from '../../dictionaries/RenderText';
import { getNegBooleans } from '../../utils/getNegBooleans';

interface AccordionNegOptionsTitleProps {
  outDebt: OutDebt;
  negOptions: NegotiationOption[];
}

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  negOptionsTitle: {
    ...theme.typography.body2,
    color: theme.palette.indigo.main,
    padding: theme.spacing(0, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0),
    },
  },
}));

const AccordionNegOptionsTitle: React.FC<AccordionNegOptionsTitleProps> = (props) => {
  const classes = useStyles();
  const { outDebt, negOptions } = props;
  let textKey = 'general_negotiationView_negOptions_introduction';

  const { isBbva, isRefinance } = getNegBooleans(outDebt, negOptions[0]);
  if (isBbva && isRefinance) textKey = 'general_negotiationView_negOptions_introduction_cant_pay';

  return (
    <Typography className={cn(classes.negOptionsTitle, 'my-2')} data-test="cy-accordionNegOptionsTitle-text">
      <RenderText
        textKey={textKey}
        isMarkdown
        context={{ isSingular: negOptions.length === 1 }}
      />
    </Typography>
  );
};

export default AccordionNegOptionsTitle;
